import { render, staticRenderFns } from "./SpecialCheck.vue?vue&type=template&id=198bd2b5"
import script from "./SpecialCheck.vue?vue&type=script&lang=js"
export * from "./SpecialCheck.vue?vue&type=script&lang=js"
import style0 from "./SpecialCheck.vue?vue&type=style&index=0&id=198bd2b5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports